import { Component } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-seo-off-page-campaigns-list',
  templateUrl: './seo-off-page-campaigns-list.component.html',
  styleUrls: ['./seo-off-page-campaigns-list.component.css'],
})
export class SeoOffPageCampaignsListComponent {
  url_aux: string = 'seoOffpageCampaigns';
  url: string = 'seoKeywordDiscoveries';
  data: Array<any> = [];
  selectedLocation: string = '';
  locationSelected: boolean = false;
  universeSelected: boolean = false;
  searchText = '';
  filteredData: Array<any> = [];
  hasSearched: boolean = false;
  searchSuggestions: string[] = [];
  uniqueLocations: string[] = [];
  filteredLocations: string[] = [];
  currentPage: number = 1;
  morePages: boolean = true;
  itemsPerPage: number = 50;
  type = '';
  modalTitle: string = '';
  modalContent: string | null = null;
  modalListItems: any[] | null = null;
  filteredUniverses: string[] = [];
  uniqueUniverses: string[] = [];
  selectedUniverse: string = '';
  filteredCategories: string[] = [];
  uniqueCategories: string[] = [];
  selectedCategory: string = '';
  lastUpdated: Date = new Date();

  portfolioStats: any = {
    total: 0,
    active: 0,
    activePct: 0,
    banked: 0,
    bankedPct: 0,
    review: 0,
    reviewPct: 0,
    archived: 0,
    archivedPct: 0,
    avgLastCheckDays: 0,
  };

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'GEO',
      route: '',
    },
    
  ]; //<i class="fa-regular fa-file-lines"></i>

  locations = [
    { value: 'orlando_fl', label: 'Orlando, FL' },
    { value: 'tampa_fl', label: 'Tampa, FL' },
    { value: 'naples_fl', label: 'Naples, FL' },
    { value: 'west_palm_beach_fl', label: 'West Palm Beach, FL' },
    { value: 'boca_raton_fl', label: 'Boca Raton, FL' },
  ];

  universes = [
    { value: 'courier', label: 'Courier' },
    { value: 'runner', label: 'Runner' },
  ];

  categories = [
    { value: 'company_brand', label: 'Company Brand' },
    { value: 'same_day_courier', label: 'Same-Day Courier' },
    { value: 'rush_courier', label: 'Rush Courier' },
    { value: 'scheduled_courier', label: 'Scheduled Courier' },
    { value: 'vip_courier', label: 'VIP Courier' },
    { value: 'concierge_courier', label: 'Concierge Courier' },
    { value: 'business_courier', label: 'Business Courier' },
    { value: 'legal_services', label: 'Legal Services' },
    { value: 'long_distance_courier', label: 'Long Distance Courier' },
    { value: 'last_mile_services', label: 'Last Mile Services' },
    { value: 'local_courier_services', label: 'Local Courier Services' },
  ];

  constructor(
    private dataService: DataService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    this.dataService
      .getDataTwo(this.url, '', this.type, this.currentPage, this.itemsPerPage)
      .subscribe((response) => {
        console.log('response ', response);
        if (response.data) {
          this.data = response.data
            .filter((item: any) => item.status === 'approved')
            .sort((a: any, b: any) => {
              return (
                new Date(b.updatedAt).getTime() -
                new Date(a.updatedAt).getTime()
              );
            });
          this.filteredData = [...this.data];
          this.updateSuggestions();
          
          if (this.uniqueLocations && this.uniqueLocations.length > 0) {
            this.selectLocation(this.uniqueLocations[0]);
          }
          this.selectUniverse('All Services');
          this.filter();
        }
      });
  }

  deleteData(id: string): void {
    if (!confirm('¿Desea eliminar la campaña?')) {
      return;
    }

    this.dataService
      .deleteData(`${this.url}/delete/${id}`)
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
        this.getData();
      });
  }

  approve(id: string): void {
    if (!confirm('¿Desea aprobar esta campaña?')) {
      return;
    }
    this.dataService
      .putData(`${this.url}/${id}/approve`, {})
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  changeStatus(id: string, status: string): void {
    const statusMsg = status === 'in_progress' ? 'iniciar' : 'pausar';
    if (!confirm(`¿Desea ${statusMsg} esta campaña?`)) {
      return;
    }
    this.dataService
      .putData(`${this.url}/${id}/status`, { status })
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  complete(id: string): void {
    if (!confirm('¿Desea marcar esta campaña como completada?')) {
      return;
    }
    this.dataService
      .putData(`${this.url}/${id}/complete`, {})
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  filter() {
    this.hasSearched = true;
    const texto = this.searchText?.trim().toLowerCase() || '';
    const locationText = this.selectedLocation?.trim().toLowerCase() || '';
    const universeText = this.selectedUniverse?.trim().toLowerCase() || '';
    const categoryText = this.selectedCategory?.trim().toLowerCase() || '';

    // Require both a location AND a universe to have been explicitly selected
    if (!this.locationSelected || !this.universeSelected) {
      this.filteredData = [];
      return;
    }

    this.filteredData = this.data.filter((item) => {
      const matchText =
        !texto ||
        (item.title && item.title.toLowerCase().includes(texto)) ||
        (item.targetKeyword &&
          item.targetKeyword.toLowerCase().includes(texto)) ||
        (item.universe && item.universe.toLowerCase().includes(texto)) ||
        (item.location && item.location.toLowerCase().includes(texto));

      const matchLocation =
        !locationText ||
        (item.location && item.location.toLowerCase().includes(locationText));

      const matchUniverse =
        !universeText ||
        universeText === 'all services' ||
        (item.universe && item.universe.toLowerCase().includes(universeText));

      const matchCategory =
        !categoryText ||
        (item.category && item.category.toLowerCase().includes(categoryText));

      return matchText && matchLocation && matchUniverse && matchCategory;
    });

    this.calculatePortfolioStats();
  }

  onLocationSearch(value: string) {
    // User is typing freely — invalidate any previous confirmed selection
    this.locationSelected = false;
    this.hasSearched = false;

    if (!value || value.trim() === '') {
      this.selectedLocation = '';
      this.filteredLocations = [...this.uniqueLocations];
      //this.filter();
      return;
    }

    const text = value.toLowerCase().trim();
    this.selectedLocation = value;
    this.filteredLocations = this.uniqueLocations.filter((city) =>
      city.toLowerCase().includes(text),
    );
    //this.filter();
  }

  selectLocation(city: string) {
    this.selectedLocation = city;
    this.locationSelected = true;
    this.hasSearched = false;
    //this.filter();
  }

  onUniverseSearch(value: string) {
    // User is typing freely — invalidate any previous confirmed selection
    this.universeSelected = false;
    this.hasSearched = false;

    if (!value || value.trim() === '') {
      this.selectedUniverse = '';
      this.filteredUniverses = [...this.uniqueUniverses];
      //this.filter();
      return;
    }

    const text = value.toLowerCase().trim();
    this.selectedUniverse = value;
    this.filteredUniverses = this.uniqueUniverses.filter((universe) =>
      universe.toLowerCase().includes(text),
    );
    //this.filter();
  }

  selectUniverse(universe: string) {
    this.selectedUniverse = universe;
    this.universeSelected = true;
    this.hasSearched = false;
    //this.filter();
  }

  onCategorySearch(value: string) {
    this.hasSearched = false;
    if (!value || value.trim() === '') {
      this.selectedCategory = '';
      this.filteredCategories = [...this.uniqueCategories];
      //this.filter();
      return;
    }

    const text = value.toLowerCase().trim();
    this.selectedCategory = value;

    this.filteredCategories = this.uniqueCategories.filter((category) =>
      category.toLowerCase().includes(text),
    );
    //this.filter();
  }

  selectCategory(category: string) {
    this.selectedCategory = category;
    this.hasSearched = false;
    //this.filter();
  }

  updateSuggestions() {
    const sugerenciasSet = new Set<string>();
    const citiesSet = new Set<string>();
    const industriesSet = new Set<string>();

    this.data.forEach((item) => {
      if (item.title) sugerenciasSet.add(item.title);
      if (item.targetKeyword) sugerenciasSet.add(item.targetKeyword);
      if (item.location) citiesSet.add(item.location);
      if (item.category) industriesSet.add(item.category);
    });

    this.searchSuggestions = Array.from(sugerenciasSet).filter(Boolean);
    this.uniqueLocations = Array.from(citiesSet).filter(Boolean).sort();
    this.uniqueCategories = Array.from(industriesSet).filter(Boolean).sort();
    this.filteredCategories = [...this.uniqueCategories];

    const servicesSet = new Set<string>();
    this.data.forEach((item) => {
      if (item.universe) servicesSet.add(item.universe);
    });
    this.uniqueUniverses = [
      'All Services',
      ...Array.from(servicesSet).filter(Boolean).sort(),
    ];
    this.filteredUniverses = [...this.uniqueUniverses];
    this.filteredLocations = [...this.uniqueLocations];

    this.selectedLocation = '';
    this.selectedUniverse = '';
    this.locationSelected = false;
    this.universeSelected = false;

    this.filter();
  }

  getStatusBadgeClass(status: string): string {
    switch (status) {
      case 'planned':
        return 'badge-secondary';
      case 'research_complete':
        return 'badge-info';
      case 'approved':
        return 'badge-primary';
      case 'in_progress':
        return 'badge-warning';
      case 'completed':
        return 'badge-success';
      case 'paused':
        return 'badge-dark';
      case 'failed':
        return 'badge-danger';
      default:
        return 'badge-light';
    }
  }

  getPriorityBadgeClass(priority: string): string {
    switch (priority) {
      case 'critical':
        return 'badge-danger';
      case 'high':
        return 'badge-warning';
      case 'medium':
        return 'badge-info';
      case 'low':
        return 'badge-secondary';
      default:
        return 'badge-light';
    }
  }

  showModal(title: string, content: string | any[]) {
    this.modalTitle = title;
    if (Array.isArray(content)) {
      this.modalListItems = content;
      this.modalContent = null;
    } else {
      this.modalContent = content;
      this.modalListItems = null;
    }
  }

  closeModal() {
    this.modalContent = null;
    this.modalListItems = null;
  }

  onKeywordAction(keyword: string) {
    // Función disponible para implementar la acción deseada al hacer click
    console.log('Action triggered for keyword:', keyword);
  }

  changeKeywordStatus(item: any, kw: any, newStatus: string): void {
    const statusMsg =
      newStatus === 'active'
        ? 'activar'
        : newStatus === 'paused'
          ? 'pausar'
          : 'deshabilitar';
    if (!confirm(`¿Desea ${statusMsg} la keyword "${kw.value}"?`)) {
      return;
    }

    const payload = {
      field: kw.field || 'keywords',
      index: kw.index,
      status: newStatus,
      itemId: kw._id,
    };

    this.dataService
      .putData(`${this.url}/${item._id}/item-status`, payload)
      .subscribe({
        next: (response) => {
          if (response.rst) {
            this.messageService.add('Estado actualizado correctamente', 'info');
            // Actualizar localmente el status para no recargar todo
            kw.status = newStatus;
            // También actualizar en el objeto original item por si acaso
            if (item.keywords && item.keywords[kw.index]) {
              item.keywords[kw.index].status = newStatus;
            }
          } else {
            this.messageService.add(response.msg, 'secondary');
          }
        },
        error: (err) => {
          console.error('Error updating keyword status:', err);
          this.messageService.add('Error al actualizar el estado', 'danger');
        },
      });
  }

  deleteKeyword(item: any, kw: any) {
    if (
      !confirm(
        `¿Estás seguro de que deseas eliminar permanentemente la keyword "${kw.value}"?`,
      )
    ) {
      return;
    }

    const payload = {
      field: kw.field || 'keywords',
      index: kw.index,
      itemId: kw._id,
    };

    this.dataService
      .putData(`${this.url}/${item._id}/item-remove`, payload)
      .subscribe({
        next: (response) => {
          if (response.rst) {
            this.messageService.add(
              'Keyword eliminada correctamente',
              'success',
            );
            this.getData();
          } else {
            this.messageService.add('Error: ' + response.msg, 'secondary');
          }
        },
        error: (err) => {
          console.error('Error deleting keyword:', err);
          this.messageService.add('Error al eliminar keyword', 'danger');
        },
      });
  }

  getKeywords(item: any): any[] {
    if (!item || !Array.isArray(item.keywords)) return [];

    // Use cached processed keywords if available to prevent constant DOM rebuilding
    if (item._processedKeywords) {
      return item._processedKeywords;
    }

    // Mock ranking data pool mirroring the reference image
    const mockPool = [
      {
        currentPos: 8,
        prevPos: 10,
        change: 2,
        trend: 'improving',
        oppRank: '#1 / 15',
        searchVolume: '1.9k',
        lastCheck: '2026-07-01',
      },
      {
        currentPos: 14,
        prevPos: 12,
        change: -2,
        trend: 'improving',
        oppRank: '#2 / 15',
        searchVolume: '2.4k',
        lastCheck: '2026-07-01',
      },
      {
        currentPos: 18,
        prevPos: 21,
        change: 3,
        trend: 'improving',
        oppRank: '#4 / 15',
        searchVolume: '1.1k',
        lastCheck: '2026-07-01',
      },
      {
        currentPos: 27,
        prevPos: 29,
        change: 2,
        trend: 'stable',
        oppRank: '#9 / 15',
        searchVolume: '720',
        lastCheck: '2026-07-01',
      },
      {
        currentPos: 41,
        prevPos: 34,
        change: -7,
        trend: 'declining',
        oppRank: '#12 / 15',
        searchVolume: '590',
        lastCheck: '2026-06-15',
      },
      {
        currentPos: 16,
        prevPos: 16,
        change: 0,
        trend: 'stable',
        oppRank: '#5 / 15',
        searchVolume: '1.3k',
        lastCheck: '2026-07-01',
      },
      {
        currentPos: 23,
        prevPos: 25,
        change: 2,
        trend: 'improving',
        oppRank: '#6 / 15',
        searchVolume: '880',
        lastCheck: '2026-07-01',
      },
      {
        currentPos: 35,
        prevPos: 28,
        change: -7,
        trend: 'declining',
        oppRank: '#11 / 15',
        searchVolume: '480',
        lastCheck: '2026-06-30',
      },
      {
        currentPos: 52,
        prevPos: 48,
        change: -4,
        trend: 'declining',
        oppRank: '#15 / 15',
        searchVolume: '390',
        lastCheck: '2026-06-30',
      },
      {
        currentPos: 12,
        prevPos: 13,
        change: 1,
        trend: 'improving',
        oppRank: '#3 / 15',
        searchVolume: '1.6k',
        lastCheck: '2026-07-01',
      },
    ];

    const processed = item.keywords
      .map((kw: any, index: number) => {
        const mock = mockPool[index % mockPool.length];
        return {
          _id: kw._id,
          value: kw.value,
          status: kw.status || 'active',
          url: kw.url,
          field: 'keywords',
          index: index,
          currentPos: kw.currentPos ?? mock.currentPos,
          prevPos: kw.prevPos ?? mock.prevPos,
          change: kw.change ?? mock.change,
          trend: kw.trend ?? mock.trend,
          oppRank: kw.oppRank ?? mock.oppRank,
          searchVolume: kw.searchVolume ?? mock.searchVolume,
          lastCheck: kw.lastCheck ?? mock.lastCheck,
        };
      })
      .filter((kw: any) => kw.value);

    // Cache the result
    item._processedKeywords = processed;
    return processed;
  }

  getLocationLabel(value: string): string {
    return this.locations.find((l) => l.value === value)?.label || value;
  }

  getUniverseLabel(value: string): string {
    return this.universes.find((u) => u.value === value)?.label || value;
  }

  getCategoryLabel(value: string): string {
    return this.categories.find((c) => c.value === value)?.label || value;
  }

  toTitleCase(str: string): string {
    if (!str) return '';
    return str.replace(
      /\w\S*/g,
      (txt) => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase(),
    );
  }

  // displayLocationFn = (value: string): string => {
  //   if (!value) return '';
  //   return this.toTitleCase(this.getLocationLabel(value));
  // };

  displayUniverseFn = (value: string): string => {
    if (!value) return '';
    return this.toTitleCase(this.getUniverseLabel(value));
  };

  displayCategoryFn = (value: string): string => {
    if (!value) return '';
    return this.toTitleCase(this.getCategoryLabel(value));
  };

  /** Returns 'fresh' if lastCheck is within 7 days, otherwise 'due' */
  getLastCheckStatus(lastCheck: string | Date): 'fresh' | 'due' {
    if (!lastCheck) return 'due';
    const checkDate = new Date(lastCheck);
    const diffMs = Date.now() - checkDate.getTime();
    const diffDays = diffMs / (1000 * 60 * 60 * 24);
    return diffDays <= 7 ? 'fresh' : 'due';
  }

  /** Compute portfolio statistics from the currently filtered keyword rows */
  calculatePortfolioStats() {
    const allKws: any[] = [];
    this.filteredData.forEach((item: any) => {
      this.getKeywords(item).forEach((kw: any) => allKws.push(kw));
    });

    const total = allKws.length;
    const active = allKws.filter((k) => k.status === 'active').length;
    const banked = allKws.filter((k) => k.status === 'banked').length;
    const review = allKws.filter((k) => k.status === 'review').length;
    const archived = allKws.filter((k) => k.status === 'disabled').length;

    const pct = (n: number) =>
      total > 0 ? Math.round((n / total) * 1000) / 10 : 0;

    // Average days since last check
    const now = Date.now();
    const kwsWithDate = allKws.filter((k) => k.lastCheck);
    const avgDays =
      kwsWithDate.length > 0
        ? Math.round(
            kwsWithDate.reduce((acc, k) => {
              const diff = now - new Date(k.lastCheck).getTime();
              return acc + diff / (1000 * 60 * 60 * 24);
            }, 0) / kwsWithDate.length,
          )
        : 0;

    this.portfolioStats = {
      total,
      active,
      activePct: pct(active),
      banked,
      bankedPct: pct(banked),
      review,
      reviewPct: pct(review),
      archived,
      archivedPct: pct(archived),
      avgLastCheckDays: avgDays,
    };
  }
}
